import React from "react";
import "./TrainerCardIcons.scss";

const TrainerCardIcons = () => (
  <div className="socialIcons">
    <div className="icon">
      <i className="fab fa-facebook-f"></i>
    </div>
    <div className="icon">
      <i className="fab fa-twitter"></i>
    </div>
    <div className="icon">
      <i className="fab fa-instagram"></i>
    </div>
  </div>
);

export default TrainerCardIcons;
